var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wizard",
        {
          ref: "formWiz",
          staticClass: "mb-3",
          attrs: {
            color: "#B1D06C",
            title: null,
            subtitle: null,
            shape: "square",
            "finish-button-text": "Submit",
            "back-button-text": "Previous",
          },
          on: { "on-complete": _vm.formSubmitted },
        },
        [
          _c(
            "tab-content",
            { attrs: { title: "Select your customer" } },
            [
              _c("SelectCustomer", {
                on: { customerSelected: _vm.customerSelected },
              }),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "Select your service" } },
            [
              _c("SelectTemplate", {
                on: { templateSelected: _vm.templateSelected },
              }),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "Modify your template" } },
            [
              _c(
                "b-container",
                { staticClass: "text-center" },
                [
                  _c("TemplateView", {
                    attrs: { templateId: _vm.templateId },
                    on: { "update:template": _vm.template },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "Modify Price & Submit" } },
            [
              _c("Price", {
                attrs: { product: _vm.templateId },
                on: { priceUpdated: _vm.updatePrice },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }